import type { DocumentInitParameters, PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api';

const publicPath = process.env.PUBLIC_URL || '';

export const PDFJS_RESOURCE_PATHS = {
  workerSrc: `${publicPath}/pdf.worker.min.mjs`,
  cMapUrl: `${publicPath}/pdfjs/cmaps/`,
  standardFontDataUrl: `${publicPath}/pdfjs/standard_fonts/`,
  imageResourcesPath: `${publicPath}/pdfjs/images/`,
} as const;

export const configurePdfJs = async () => {
  const pdfjsLib = await import('pdfjs-dist');
  pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_RESOURCE_PATHS.workerSrc;
  return pdfjsLib;
};

export const createPdfDocumentParameters = (
  data: ArrayBuffer | Uint8Array,
): DocumentInitParameters => ({
  data,
  cMapUrl: PDFJS_RESOURCE_PATHS.cMapUrl,
  cMapPacked: true,
  standardFontDataUrl: PDFJS_RESOURCE_PATHS.standardFontDataUrl,
  enableXfa: true,
});

export const loadPdfDocument = async (
  data: ArrayBuffer | Uint8Array,
): Promise<PDFDocumentProxy> => {
  const pdfjsLib = await configurePdfJs();
  return pdfjsLib.getDocument(createPdfDocumentParameters(data)).promise;
};
